
export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-teal-900 text-white">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 flex items-center justify-center bg-teal-500 rounded-lg">
                <i className="ri-shopping-bag-3-line text-2xl text-white"></i>
              </div>
              <span className="text-xl font-bold">PackDeRopa.com</span>
            </div>
            <p className="text-gray-300 text-sm">
              Tu proveedor de confianza para packs de ropa al por mayor con envío gratuito.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Enlaces Rápidos</h3>
            <ul className="space-y-2">
              <li>
                <a href="/" className="text-gray-300 hover:text-teal-400 transition-colors text-sm cursor-pointer">
                  Inicio
                </a>
              </li>
              <li>
                <a href="/catalog" className="text-gray-300 hover:text-teal-400 transition-colors text-sm cursor-pointer">
                  Catálogo
                </a>
              </li>
              <li>
                <a href="/packages" className="text-gray-300 hover:text-teal-400 transition-colors text-sm cursor-pointer">
                  Packs Especiales
                </a>
              </li>
              <li>
                <a href="/contact" className="text-gray-300 hover:text-teal-400 transition-colors text-sm cursor-pointer">
                  Contacto
                </a>
              </li>
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Categorías</h3>
            <ul className="space-y-2">
              <li>
                <a href="/catalog?category=camisetas" className="text-gray-300 hover:text-teal-400 transition-colors text-sm cursor-pointer">
                  Camisetas
                </a>
              </li>
              <li>
                <a href="/catalog?category=polos" className="text-gray-300 hover:text-teal-400 transition-colors text-sm cursor-pointer">
                  Polos
                </a>
              </li>
              <li>
                <a href="/catalog?category=chaquetas" className="text-gray-300 hover:text-teal-400 transition-colors text-sm cursor-pointer">
                  Chaquetas
                </a>
              </li>
              <li>
                <a href="/catalog?category=sudaderas" className="text-gray-300 hover:text-teal-400 transition-colors text-sm cursor-pointer">
                  Sudaderas
                </a>
              </li>
              <li>
                <a href="/catalog?category=chalecos" className="text-gray-300 hover:text-teal-400 transition-colors text-sm cursor-pointer">
                  Chalecos
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Contacto</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line text-teal-400 mt-1"></i>
                <div>
                  <a href="mailto:mdmarketplacespain@gmail.com" className="text-gray-300 hover:text-teal-400 transition-colors text-sm cursor-pointer block">
                    mdmarketplacespain@gmail.com
                  </a>
                  <a href="mailto:didovoley1@icloud.com" className="text-gray-300 hover:text-teal-400 transition-colors text-sm cursor-pointer block">
                    didovoley1@icloud.com
                  </a>
                </div>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-whatsapp-line text-teal-400"></i>
                <a 
                  href="https://wa.me/34600000000?text=Hola,%20estoy%20interesado%20en%20sus%20packs%20de%20ropa"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-teal-400 transition-colors text-sm cursor-pointer"
                >
                  WhatsApp
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 pt-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm">
            © {currentYear} PackDeRopa.com. Todos los derechos reservados.
          </p>
          <a 
            href="https://readdy.ai/?ref=logo"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
